import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';

const MiniSparkline = ({ data }) => {
  if (!data || data.length === 0) return null;

  const max = Math.max(...data);
  const min = Math.min(...data);
  const range = max - min;

  const points = data.map((value, index) => {
    const x = (index / (data.length - 1)) * 100;
    const y = range === 0 ? 50 : ((max - value) / range) * 100;
    return `${x},${y}`;
  }).join(' ');

  return (
    <svg className="w-full h-8" viewBox="0 0 100 100" preserveAspectRatio="none">
      <polyline
        points={points}
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        vectorEffect="non-scaling-stroke"
        className="text-ink-400"
      />
    </svg>
  );
};

const KPICard = ({
  titulo,
  valor,
  cambio,
  sparkline,
  icono: Icon,
  formato = 'numero',
  desglose
}) => {
  const formatearValor = (val) => {
    if (val === null || val === undefined) return '—';

    switch (formato) {
      case 'moneda':
        return `$${val.toLocaleString('es-MX', { minimumFractionDigits: 2 })}`;
      case 'porcentaje':
        return `${val.toFixed(1)}%`;
      default:
        return val.toLocaleString('es-MX');
    }
  };

  const cambioNum = cambio ? parseFloat(cambio.replace(/[+%]/g, '')) : 0;
  const esCambioPositivo = cambioNum > 0;

  return (
    <div className="bg-white rounded-lg p-6 shadow-soft border border-ink-200 animate-fade-in">
      <div className="flex items-center justify-between mb-4">
        <div className="w-10 h-10 rounded-lg bg-ink-100 flex items-center justify-center">
          {Icon && <Icon size={20} className="text-ink-700" />}
        </div>
        {cambio && (
          <div className={`text-xs flex items-center gap-1 ${
            esCambioPositivo ? 'text-green-600' : 'text-red-600'
          }`}>
            {esCambioPositivo ? <TrendingUp size={14} /> : <TrendingDown size={14} />}
            <span>{cambio}</span>
          </div>
        )}
      </div>

      <p className="text-ink-500 text-sm font-medium">{titulo}</p>
      <p className="text-2xl font-bold text-ink-900 mt-1">{formatearValor(valor)}</p>

      {desglose && (
        <p className="text-xs text-ink-500 mt-2">{desglose}</p>
      )}

      {sparkline && sparkline.length > 0 && (
        <div className="mt-3">
          <MiniSparkline data={sparkline} />
        </div>
      )}
    </div>
  );
};

export default KPICard;
